import { type PathKey } from '~/apps/applicationAdmin/routes/paths'

export const pathKey = 'coreMembersList' satisfies PathKey
